import { quote } from "../../types/carouselInterface";

export const QuoteCarouselContents: quote[] = [
  {
    name: "W. Jackson Watts",
    subtitle: "Pastor at Grace Church in Arnold, MO",
    testimony:
      "Zea was just the person we needed to rebuild our church website: courteous, responsive, affordable, and capable. He delivered on what he promised. Whenever there was a problem, he addressed it promptly. We are very satisfied with the result, and commend his services to other churches, non-profits, and companies.",
  },
  {
    name: "J. A. Hunter Th.M.",
    subtitle: "Pastor at First Free Will Baptist Church of Waverly, TN",
    testimony:
      "I reached out to Zea and received a quick response from him. He developed and drafted some great ideas for the website design based on the church's history and community. He finished the website in a timely manner and at a very reasonable cost. He has since served as a remote IT administrator of the church, providing continued bug fixes and monthly support for a competitive annual rate. I will continue to utilize his services in future needs, and I would highly recommend him for any coding and web development needs.",
  },
];
